import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { RecentTicket } from 'src/app/models/core/recent-ticket.model';
import { TicketActionsService } from 'src/app/services/ticket/ticket-actions.service';

@Component({
  selector: 'app-confirm-delete-ticket-modal',
  templateUrl: './confirm-delete-ticket-modal.component.html',
  styleUrls: ['./confirm-delete-ticket-modal.component.scss'],
  standalone: false
})
export class ConfirmDeleteTicketModalComponent {
  @Input() ticket!: RecentTicket;
  @Input() onSuccess?: () => void;

  constructor(
    private modalCtrl: ModalController,
    private ticketActions: TicketActionsService,
  ) { }

  confirmDelete() {
    this.ticketActions.deleteTicket(this.ticket.id, () => {
      if (this.onSuccess) {
        this.onSuccess();
      }

      setTimeout(() => {
        this.scrollToTop();
      }, 200);

      this.modalCtrl.dismiss({ confirm: true });
    });
  }

  private scrollToTop() {
    const ionContent = document.querySelector('ion-content');
    if (ionContent) {
      ionContent.scrollToTop(300);
    }
  }

  close() {
    this.modalCtrl.dismiss();
  }

  getTicketAmount(ticket: RecentTicket): number {
    return ticket.price_product ? ticket.price_product * ticket.quota : 0;
  }

  shouldShowReference(): boolean {
    const ref = this.ticket?.reference || '';
    return ref.toUpperCase() !== 'SIN REFERENCIA';
  }
}
